module.exports = __webpack_public_path__ + "img/汇源通.f61d0c28.png";